module.exports = __webpack_public_path__ + "static/media/cross_greyscale.a3515f9d.jpg";